module.exports = __webpack_public_path__ + "static/media/Highland Ave San Carlos, CA7.fe6f2126.jpg";